export default "__VITE_ASSET__3071e889__"